import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {Link} from 'react-router-dom'
import classes from './Vp.module.css';
import Nav from './../Nav/hmdn';
import Ftr from './../Footer/Ftr';
import axios from 'axios';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Cookies from 'js-cookie';
import Slider from 'react-slick';

const Viewproductform = (product) => {
const userPrimaryKeyCookie = Cookies.get('userPrimaryKey');

  const sliderRef = useRef(null);

  useEffect(() => {
    // Initialize Slick slider once the component has mounted
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0); // Move to the first slide initially (optional)
    }
  }, []);

  const slickSettings = {
    
    dots: false,
    fade: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,  
  
    
    // Add more settings as per your requirement
  };


  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://infisea.com/getproducts');
        console.log(response);
        setProducts(response.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchProducts();
  }, []);


  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/Admin_dashboard');
  };



 const handleGoLogin= () => {
       navigate('/login');
  };

/*
  // Check session status every 5 minutes (adjust the interval as needed)
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get('https://infisea.com/session');
        const isAuthenticated = response.data.isAuthenticated;

        if (!isAuthenticated) {
          // Session expired, perform logout
         // handleLogout();
        }
      } catch (error) {
        console.error('Error checking session status:', error);
      }


    };
const sessionCheckInterval = setInterval(checkSession, 10 * 1000); // Check every 10 seconds
    //const sessionCheckInterval = setInterval(checkSession, 5 * 60 * 1000);
    return () => clearInterval(sessionCheckInterval);
  }, []);



  if (!userPrimaryKeyCookie) {
    // You can add loading spinner or handle the case when user data is not loaded yet
    return <p><br/>
        <center> <button className={classes.addToCart} onClick={handleGoLogin}> ←  GO BACK To Login Page</button> </center>
      <br /></p>;
  }
*/





  
  const remove = async(CategoryID) => {
  
    try{
      await axios.delete('https://infisea.com/removeproduct/'+CategoryID, {
      })
      window.location.reload();
    }
    catch(err){
      console.log(err);
    
    }
  };

  return (
    <div>
      <Nav />

      <br/>  <br/>  <br/>

      <div className={classes.Su}>
     
        <div>
        

        <div className={classes.Heading}>
       <h3>  Our Product .... </h3>
        </div>
          
          <ul  className={classes.cardb} >

            
          {products.map((product) => (
              <li key={product.CategoryID} className={classes.card}>
<center>
<Slider ref={sliderRef} {...slickSettings}>
      {product.Images && product.Images.split(',').map((image, index) => (
          <div key={index}>
            <img src={`http://localhost:8000/uploads/${image}`} alt={`Product ${index + 1}`} className={classes.Image}/>
          </div>
        ))}
    </Slider>
    </center>

              <div className={classes.middle}>PRODUCT INFORMATION</div>
              <div className={classes.lower}>
                <h3 className={classes.Title}>{product.ProductName}</h3>
             
               <div className={classes.clm}>
                <p className={classes.info}><span className={classes.io}>Price in <span className={classes.ior}> ₹ </span>: </span>{product.Price}</p>
                <p className={classes.info}><span className={classes.io}>Quantity : </span>{product.StockQuantity}</p>
                </div>
                  
                <div className={classes.clm}>
                <p className={classes.info}><span className={classes.io}>Weight : </span>{product.Weight}</p>
                <p className={classes.info}><span className={classes.io}>Ratings : </span>{product.Rating}</p>
                </div>

                <p className={classes.info}><span className={classes.io}>Description : </span><br/>{product.Description}</p>
              

                <div className={classes.clm}>
                <p className={classes.info}><span className={classes.io}>Id : </span>{product.ProductID}</p>  
                <p className={classes.info}><span className={classes.io}>Is Available : </span>{product.IsAvailable}</p>
                </div>

                <p className={classes.info}><span className={classes.ior}>*</span>Availability, IF AVAILABE = 1, UNAVAILABLE = 0</p>
             
              <center> <Link to={`/Updateproduct/${product.CategoryID}`}><button className={classes.addToCart}> UPDATE PRODUCT </button></Link>
              <br/>
                             <td className={classes.td}><button className={classes.addToCart1}  onClick={() => remove(product.CategoryID)}>REMOVE</button></td> </center>
             </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <center> <button className={classes.addToCart} onClick={handleGoBack}> ←  GO BACK</button> </center>

      <Ftr />
    </div>
  );
};

export default Viewproductform;
